import script from "./lyWaterMark.vue?vue&type=script&setup=true&lang=js"
export * from "./lyWaterMark.vue?vue&type=script&setup=true&lang=js"

import "./lyWaterMark.vue?vue&type=style&index=0&id=7b89cd20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b89cd20"]])

export default __exports__